import { rowToMapData } from "../../NComponent/pms/MyTeamPlanV2/constants";
import {
  fetchAllData,
  generateUserType,
} from "../../NComponent/pms/MyTeamPlanV2/helpers";
import { getUserId } from "../../Utils/Common/Library";

export const fetchData = async (payloads, role, partialRows) => {
  const data = await fetchAllData(payloads, role);
  const mappedRows = data.map((item) => {
    const newItem = {};
    rowToMapData.forEach((rowField) => {
      if (rowField === "UserType") {
        newItem[rowField] = generateUserType(getUserId(), item.Dimensions);
      } else if (rowField === "HIDDENval") {
        newItem[rowField] = item;
      } else if (typeof rowField === "string") {
        newItem[rowField] = item[rowField];
      } else {
        newItem[rowField] = "";
      }
    });
    return newItem;
  });

  let rows = [];
  if (partialRows) {
    const newMappedRows = [...partialRows, ...mappedRows].sort((a, b) => {
      if (a[0] < b[0]) return -1;
      if (a[0] > b[0]) return 1;
      return 0;
    });
    rows = newMappedRows;
  } else {
    rows = mappedRows;
  }
  return rows;
};
